import { DEFAULT_FINAL_STEP_TEXT, DEFAULT_WHATSAPP_MESSAGE } from './defaults'
import { ARTICLE_QUIZZES, SLUG_TO_DOC_ID } from './registry'
import { ResolvedArticleQuiz } from './types'

export interface GetArticleQuizInput {
  docId?: string | null
  slug?: string | null
}

export function getArticleQuiz(input: GetArticleQuizInput): ResolvedArticleQuiz | null {
  const id = input.docId ?? (input.slug ? SLUG_TO_DOC_ID[input.slug] : undefined)
  if (!id) return null

  const config = ARTICLE_QUIZZES[id]
  if (!config) return null

  return {
    questions: config.questions,
    finalStepText: { ...DEFAULT_FINAL_STEP_TEXT, ...config.finalStep },
    whatsappMessage: config.whatsappMessage ?? DEFAULT_WHATSAPP_MESSAGE,
  }
}
